export const HttpClient = (getAccessTokenSilently) =>
    async (path, options) => {
        options = options || {};
        if (!options.headers)
            options.headers = {}
        options.headers['Accept'] = 'application/json';

        if (getAccessTokenSilently) {
            const token = await getAccessTokenSilently();
            options.headers['Authorization'] = `Bearer ${token}`;
        }

        if (!options.method) {
            options.method = "GET";
            if (options.body)
                options.method = "POST";
        }


        return fetch(`${process.env.GATSBY_API_URL}/${path}`, options);
    };